// extracted by mini-css-extract-plugin
export default {"edit_part":"edit_edit_part__nf4kC","edit":"edit_edit__U3Mdn"};